import gql from 'graphql-tag'

export const userDeleteFromCompany = gql`
  mutation userDeleteFromCompany($userId: ID!, $companyId: ID!) {
    userDeleteFromCompany(input: { userId: $userId, companyId: $companyId }) {
      deletedUserId
    }
  }
`
